<template>
  <div class="container1">
    <h2 v-if="results">Ranked Results</h2>
    <div v-if="results" class="control-buttons">
      <v-btn @click="expandAll"> expand all  </v-btn>
      <v-btn @click="bestPath"> best path </v-btn>
      <v-btn @click="collapseAll"> collapse all  </v-btn>
      <v-btn @click="showhidden"> show hidden results ( {{hiddenItems.length}} )  </v-btn>
    </div>
    <ul v-if="results" class="list-items">
      <li  class="list-item" v-for="hit in resultsArr"  :key="hit._id">
        <div class="prod-name">
          {{ hit._source.name || hit._source.title }}
          <span class="hide-icon" @click="HideItem(hit._id)"> <v-icon

              color="blue darken-2"
          >
      mdi-magnify-minus
    </v-icon></span>
        </div>
        <h4>Explanation </h4>
        <TreeItem :explanation="hit._explanation" :status="control" />

        <hr />
      </li>
    </ul>
  </div>
</template>

<script>

import TreeItem from "./TreeItem.vue";
export default {
  data() {
    return {
      control : "",
      hiddenItems : [],
    }
  },
  name: "SearchResults",
  components: {
    TreeItem,
  },
  props : ["results"],
  computed : {
    resultsArr() {
      return this.results.hits.hits.filter((x) => { return !this.hiddenItems.includes(x._id) });
    }
  },
  methods : {
    HideItem(id) {
      this.hiddenItems.push(id);
    },
    showhidden() {
      this.hiddenItems = [];
    },
    expandAll() {
     
     this.control = "openall"+Math.random()
    },
    bestPath() {
     
     this.control = "bestpath"+Math.random()
    },
    collapseAll(){
   
    this.control = "closeall"+Math.random();
    }

  }
  
};
</script>

<style scoped>

.list-item .prod-name {
  -webkit-box-shadow: -7px -6px 18px -3px rgba(253, 255, 255, 0.91);
  box-shadow: -7px -6px 18px -3px x rgba(161, 161, 161, 0.91);
  border: 3px solid;
  border-image: linear-gradient(45deg, rgb(49, 49, 49), rgb(122, 122, 122)) 1;
  width: 100%;
  color: var(--gray-dark);
  margin: 30px 0;
  padding: 15px;
  height: auto;
  position: relative;
  font-weight: bold;
  position: relative;
}
.control-buttons button {
  margin-left: 10px
}
.list-items  {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.list-item  {
  width: 48%;
}
.hide-icon {
  position: absolute;
  right: 0;
  bottom: 0;
  cursor: pointer;
}
</style>